.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.625rem 0;
  border-bottom: 1px solid var(--rule);
}

.text {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.title {
  font-family: var(--font-body);
  font-size: var(--text-min-body);
  color: var(--ink);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.detail {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/*
 * `LGH-029` §1. Deliberately NOT truncated like `.detail` — a policy flag's
 * reason carries the specific numbers (R-075's as-of, the actual balance and
 * limit), and clipping the one sentence that makes it actionable would
 * recreate the "over limit, no instant" failure this estate already spent a
 * week removing.
 */
.policyFlag {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--stop);
  white-space: normal;
}
